import { Component, Input } from '@angular/core';
import { AdvisoryMessageBanner } from './data-models/advisory-message.interface';

@Component({
  selector: 'idp-advisory-message',
  templateUrl: './advisory-message.component.html',
  styleUrls: ['./advisory-message.component.scss']
})
export class AdvisoryMessageComponent {
  @Input() config: AdvisoryMessageBanner = {} as AdvisoryMessageBanner;
}
